import {
    BooleanField,
    DataTable,
    EditButton,
    List,
    SearchInput,
    TextField
} from "@/components/admin";

const postFilters = [
    <SearchInput source="q" alwaysOn key="search" placeholder="Search templates..." />,
];

export const TermsTemplateList = () => (
    <List filters={postFilters} exporter={false}>
        <DataTable>
            <DataTable.Col source="name" label="Template Name">
                <TextField source="name" />
            </DataTable.Col>
            <DataTable.Col source="is_default" label="Default">
                <BooleanField source="is_default" looseValue />
            </DataTable.Col>
            <DataTable.Col>
                <div className="flex justify-end gap-2">
                    <EditButton />
                </div>
            </DataTable.Col>
        </DataTable>
    </List>
);
